const locale: Locale = {
  ko: {
    title1: '이런 청원은 삭제/숨김 또는 반려 처리될 수 있습니다',
    title2: '이런 청원은 답변이 어려울 수 있습니다',

    content1_1:
      '동일한 내용으로 중복 게시된 청원은 가장 동의수가 많은 청원만 남기고 반려될 수 있습니다.',
    content1_2:
      '욕설 및 비속어를 사용한 청원은 관리자에 의해 삭제 또는 일부 내용 숨김 처리될 수 있습니다.',
    content1_3:
      '폭력적, 선정적 또는 특정 집단에 대한 혐오 표현 등 유해한 내용을 담은 청원은 관리자에 의해 삭제될 수 있습니다.',
    content1_4:
      '개인정보, 허위사실, 타인의 명예를 훼손하는 내용이 포함된 청원은 관리자에 의해 삭제 또는 일부 내용 숨김 처리될 수 있습니다.',

    content2_1:
      '타인을 악의적으로 비방하거나 명예를 훼손하기 위한 목적으로 작성된 청원에는 답변이 어려울 수 있습니다.',
    content2_2:
      '청원 주요 내용이 허위사실로 밝혀진 경우 답변이 어려울 수 있습니다.',
    content2_3:
      'GIST 구성원 공동의 이익과 관련없는 청원의 경우 답변이 어려울 수 있습니다.',
    content2_4_1:
      '부패/예산부당집행‚ 인권침해‚ 성희롱‚ 괴롭힘‚ 연구관련 부정행위 등의 일반 민원 신고는 GIST ',
    center: 'GIST 공익신고센터',
    content2_4_2: '를 이용할 수 있습니다.',

    petitionBtn: '청원하기',
  },
  en: {
    title1: 'Such a petition could be deleted or hidden',
    title2: 'Such a petition could be difficult to answer',

    content1_1:
      'Petitions with the similar content can be rejected, \
      except the petition with the highest number of agreements.',
    content1_2:
      'A petition using swear word or profanity could be deleted or partially hidden by the administrator.',
    content1_3:
      'A petition containing harmful content, such as violent, sensational, \
      or hateful expression against a particular group, could be deleted by the administrator.',
    content1_4:
      'A petition containing privacy, misinformation, \
      or content that damages the reputation of others could be deleted or partially hidden by the administrator.',

    content2_1:
      'It could be difficult to respond to petitions written \
      for the purpose of maliciously slandering or defaming others.',
    content2_2:
      'If the main contents of the petition are found to be false, it could be difficult to answer.',
    content2_3:
      'It could be difficult to answer a petition that is not related to the common interests of GIST members.',
    content2_4_1:
      'General complaints such as corruption/budget unfair execution, human rights violations, \
      sexual harassment, harassment, and research-related irregularities can be reported to the ',
    center: 'GIST Public Interest Reporting Center',
    content2_4_2: '.',

    petitionBtn: 'Start a Petition',
  },
}

export default locale
